export const TOKEN_CONTRACTS = [
  {
    name: `Dolly`,
    symbol: `DOLLY`,
    address: `0xff54da7caf3bc3d34664891fc8f3c9b6dea6c7a5`,
    image_url: `https://dopple.finance/_next/image?url=%2Fimages%2Ficons%2Fdolly.svg&w=64&q=75`
  },
  {
    name: `Dopple`,
    symbol: `DOP`,
    address: `0x116997f67a26E72F036b3225476a6Fe023fD8251`,
    image_url: `https://raw.githubusercontent.com/trustwallet/assets/9a4d428c9eb9790e6a758154df5ce165de27067d/blockchains/smartchain/assets/0x116997f67a26E72F036b3225476a6Fe023fD8251/logo.png`
  },
  {
    name: `Twindex`,
    symbol: `TWIN`,
    address: `0x3806aae953a3a873D02595f76C7698a57d4C7A57`,
    image_url: `https://raw.githubusercontent.com/chawanvtp/Dopple/main/assets/tokens/0x3806aae953a3a873D02595f76C7698a57d4C7A57.png`
  },
  {
    name: `Tesla`,
    symbol: `dTSLA`,
    address: `0x17aCe02e5C8814BF2EE9eAAFF7902D52c15Fb0f4`,
    image_url: `https://raw.githubusercontent.com/chawanvtp/Dopple/main/assets/tokens/0x17aCe02e5C8814BF2EE9eAAFF7902D52c15Fb0f4.svg`
  },
  {
    name: `Apple`,
    symbol: `dAAPL`,
    address: `0xC10b2Ce6A2BCfdFDC8100Ba1602C1689997299D3`,
    image_url: `https://raw.githubusercontent.com/chawanvtp/Dopple/main/assets/tokens/0xC10b2Ce6A2BCfdFDC8100Ba1602C1689997299D3.svg`
  },
  {
    name: `Amazon`,
    symbol: `dAMZN`,
    address: `0x1085B90544ff5C421D528aAF79Cc65aFc920aC79`,
    image_url: `https://raw.githubusercontent.com/chawanvtp/Dopple/main/assets/tokens/0x1085B90544ff5C421D528aAF79Cc65aFc920aC79.svg`
  },
  {
    name: `Google`,
    symbol: `dGOOGL`,
    address: `0x9C169647471C1C6a72773CfFc50F6Ba285684803`,
    image_url: `https://raw.githubusercontent.com/chawanvtp/Dopple/main/assets/tokens/0x9C169647471C1C6a72773CfFc50F6Ba285684803.svg`
  }
]

export const ORACLE_CONTRACTS = [
  {
    name: `DOLLY OracleAddress`,
    address: `0xa442c34d88f4091880AEEE16500B088306562caa`
  },
  {
    name: `BNB OracleAddress`,
    address: `0xc06fcEE64b08E666Bab5fda9c503B36826F8948e`
  },
  {
    name: `AAPL OracleAddress`,
    address: `0xa715B865a981Db7E6d500030b6B5F572df184D59`
  },
  {
    name: `GOOG LOracleAddress`,
    address: `0x389a094aa1b549df4515F5f4B691C0c32706fB5b`
  },
  {
    name: `AMZN OracleAddress`,
    address: `0xC032d80C513Ca88adD0de1f452995FcC831e173e`
  },
  {
    name: `TSLA OracleAddress`,
    address: `0x29ED6B59E46dD0751259198E552541edDE7c3F25`
  }
]

export const OTHER_CONTRACTS = [
  {
    name: `DFI Protocol`,
    address: `"0x37f5a7D8bBB1cc0307985D00DE520fE30630790c`
  },
  {
    name: `Price Feeds`,
    address: `0xd4f061a6a276f8B0Ae83D210D838B45fCC7532B2`
  },
  {
    name: `Loan Token Logic Standard`,
    address: `0x6e0C17f56d0d97f83d400A66C508307Bce6f8E38`
  }
]